// extracted by mini-css-extract-plugin
export default {"accion-barra":"BarraProgreso_accion-barra__twS0j","barraprogreso":"BarraProgreso_barraprogreso__qP42q"};